// This event fires whenever an item has been added to the cart.
// The product object is passed within the detail object.
document.addEventListener("flu:cart:item-added", function (evt) {
  datalayerAddToCart(evt.detail.product);
});

// This event fires whenever an item has been removed from the cart.
// The product object is passed within the detail object.
document.addEventListener("flu:cart:item-removed", function (evt) {
  datalayerRemoveItem(evt);
});
